import WebGalleryVideoAlbum from './WebGalleryVideoAlbum';

export default WebGalleryVideoAlbum;
